/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LongTermCareInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import SelectInput from '../Fields/SelectInput';

class LongTermCareInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      longTermCareInsuranceCompany: '',
      longTermCareInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { insuredClientOptions } = this.props;
    const {
      longTermCareInsuranceCompany,
      longTermCareInsuranceInsuredClientId,
    } = this.state;
    const nameList = [];
    if (longTermCareInsuranceInsuredClientId) nameList.push(getClientPicklistValue(insuredClientOptions, longTermCareInsuranceInsuredClientId));
    if (longTermCareInsuranceCompany) nameList.push(longTermCareInsuranceCompany);
    return nameList.join(' - ') || 'New policy';
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { longTermCareInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          placeholder="Insurance company"
          name={`longTermCareInsuranceCompany.${id}`}
          answerKey="longTermCareInsuranceCompany"
          onChange={(name, value) => onChange('longTermCareInsuranceCompany', value)
          }
        />
        <CurrencyInput
          placeholder="Monthly benefit"
          name={`longTermCareInsuranceBenefit.${id}`}
          answerKey="longTermCareInsuranceBenefit"
        />
        <TextInput
          placeholder="Benefit period"
          name={`longTermCareInsurancePeriod.${id}`}
          answerKey="longTermCareInsurancePeriod"
        />
        <CurrencyInput
          placeholder="Annual premium"
          name={`longTermCareInsurancePremium.${id}`}
          answerKey="longTermCareInsurancePremium"
        />
        <SelectInput
          label="Who is insured?"
          name={`longTermCareInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="longTermCareInsuranceInsuredClientId"
          onChange={(name, value) => onChange('longTermCareInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`longTermCareInsuranceInsuredNotes.${id}`}
          answerKey="longTermCareInsuranceInsuredNotes"
          onChange={(name, value) => onChange('longTermCareInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(longTermCareInsuranceInsuredClientId)}
        />
        <CurrencyInput
          placeholder="Annual purchase option"
          name={`longTermCareInsurancePurchaseOption.${id}`}
          answerKey="longTermCareInsurancePurchaseOption"
        />
        <BoolInput
          label="Cost of living rider?"
          name={`longTermCareInsuranceHasCostOfLiving.${id}`}
          answerKey="longTermCareInsuranceHasCostOfLiving"
        />
        <BoolInput
          label="Shared care option?"
          name={`longTermCareInsuranceHasSharedCare.${id}`}
          answerKey="longTermCareInsuranceHasSharedCare"
          checkedChildren={
            <TextInput
              placeholder="Additional insured?"
              name={`longTermCareInsuranceAdditionalInsured.${id}`}
              answerKey="longTermCareInsuranceAdditionalInsured"
            />
          }
        />
      </LabeledVerticalExpander>
    );
  }
}

LongTermCareInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

LongTermCareInsuranceList.defaultProps = {
  expanded: false,
};

const LongTermCareInsurance = ({ insuredClientOptions }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      height={400}
      title="Long-Term Care Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - long-term care"
        addLabel="Add a policy"
        keyPrefix="longTermCareInsurances"
        Of={LongTermCareInsuranceList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

LongTermCareInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default LongTermCareInsurance;
